import { useEffect, useState } from "react";
import { Activity, Clock, MapPin } from "lucide-react";
import api from "@/lib/api";

const ROLE = { super_admin: "Super Admin", store_manager: "Store Manager", fulfillment_staff: "Fulfillment Staff" };

const dur = (s) => {
  if (!s) return "—";
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
  return h ? `${h}h ${m}m` : `${m}m`;
};
const ago = (iso) => {
  if (!iso) return "never";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};
const label = (p) => (!p || p === "/admin" ? "Dashboard" : p.replace("/admin/", "").replace(/-/g, " "));

export default function AdminActivity() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/activity").then(({ data }) => setRows(data.users || [])).catch(() => {});
  useEffect(() => { load(); const id = setInterval(load, 15000); return () => clearInterval(id); }, []);

  const onlineCount = rows.filter((r) => r.online).length;

  return (
    <div data-testid="admin-activity">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="font-heading text-3xl flex items-center gap-2"><Activity size={22} /> Team Activity</h1>
          <p className="font-body text-sm text-ink/50 mt-1">See who's online, how long they've been active, and what they're viewing. Refreshes every 15s.</p>
        </div>
        <span className="font-body text-sm text-ink/70" data-testid="activity-online-count"><span className="inline-block w-2.5 h-2.5 rounded-full bg-green-500 mr-2" />{onlineCount} online</span>
      </div>

      <div className="space-y-3">
        {rows.map((u) => (
          <div key={u.id} className="adm-card flex flex-col md:flex-row md:items-center gap-4" data-testid={`activity-row-${u.id}`}>
            <div className="flex items-center gap-3 md:w-64">
              <span className={`w-3 h-3 rounded-full flex-none ${u.online ? "bg-green-500 animate-pulse" : "bg-ink/20"}`} data-testid={`activity-dot-${u.online ? "online" : "offline"}`} title={u.online ? "Online" : "Offline"} />
              <div>
                <p className="font-body font-medium text-sm">{u.name}</p>
                <p className="font-body text-[0.65rem] uppercase tracking-wide2 text-ink/40">{ROLE[u.role] || u.role}</p>
              </div>
            </div>
            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-3 font-body text-[0.72rem]">
              <div><p className="text-ink/40 uppercase tracking-wide2 text-[0.55rem] mb-0.5 flex items-center gap-1"><Clock size={10} /> Session</p><p className="text-ink/80">{u.online ? dur(u.session_seconds) : `seen ${ago(u.last_seen)}`}</p></div>
              <div><p className="text-ink/40 uppercase tracking-wide2 text-[0.55rem] mb-0.5 flex items-center gap-1"><MapPin size={10} /> Viewing</p><p className="text-ink/80 capitalize">{u.online ? label(u.current_path) : "—"}</p></div>
              <div className="col-span-2 md:col-span-1"><p className="text-ink/40 uppercase tracking-wide2 text-[0.55rem] mb-0.5">Recent pages</p><p className="text-ink/60 capitalize truncate">{(u.recent_pages || []).slice(0, 5).map((v) => label(v.path)).join(" · ") || "—"}</p></div>
            </div>
          </div>
        ))}
        {rows.length === 0 && <p className="font-body text-sm text-ink/40">No admin users yet.</p>}
      </div>
    </div>
  );
}
